import { VendorProductPage } from "@/features/vendor-app/pages/VendorProductPage";
import { createFileRoute } from "@tanstack/react-router";

export type VendorProductSearch = {
	search?: string;
	status?: string;
};

const str = (v: unknown): string | undefined =>
	typeof v === "string" && v !== "" ? v : undefined;

export const Route = createFileRoute("/vendor/products/")({
	validateSearch: (search: Record<string, unknown>): VendorProductSearch => ({
		search: str(search.search),
		status: str(search.status),
	}),
	component: VendorProductPage,
});
